import { cn } from "@/utils/cn";
import type { InputHTMLAttributes, ReactNode } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  containerClassName?: string;
}

export function Input({
  label,
  helper,
  leftIcon,
  rightIcon,
  className,
  containerClassName,
  ...props
}: InputProps) {
  return (
    <div className={cn("w-full", containerClassName)}>
      {label && (
        <label className="block text-sm font-medium !text-black mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
            {leftIcon}
          </div>
        )}
        <input
          className={cn(
            "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm !text-black placeholder:text-[#94A3B8] focus:border-[#ff0000] focus:outline-none focus:ring-2 focus:ring-[#ff0000]/10 transition-all",
            leftIcon && "pl-10",
            rightIcon && "pr-10",
            className
          )}
          {...props}
        />
        {rightIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
            {rightIcon}
          </div>
        )}
      </div>
      {helper && (
        <p className="mt-1.5 text-xs text-[#5A6A85]">
          {helper}
        </p>
      )}
    </div>
  );
}
